import { createAction, props } from '@ngrx/store';
import { Coupons, CouponsDTO, CouponsFilters } from '../../commons/models/coupons';

// Caricamento dei coupon
export const loadCoupons = createAction('[Coupons] Load Coupons', props<{ page?: number, perPage?: number, order?: string, direction?: string, filters?: CouponsFilters, includes?: string[] }>());
export const loadCouponsCompleted = createAction('[Coupons] Load Coupons Completed', props<{ coupons: CouponsDTO[], currentPage: number, total: number, perPage: number, order?: string, direction?: string, filters?: CouponsFilters, includes?: string[] }>());
export const loadCouponsFailed = createAction('[Coupons] Load Coupons Failed', props<{ error: any }>());

// Paginazione, ordinamento e filtri
export const changePage = createAction('[Coupons] Change page', props<{ page: number, size: number }>());
export const changeSort = createAction('[Coupons] Change sort', props<{ order: string, direction: string }>());
export const changeFilters = createAction('[Coupons] Change filters', props<{ filters: CouponsFilters }>());

// Modifica e visualizzazione coupon
export const editCoupon = createAction('[Coupons] Edit coupon', props<{ coupon: Coupons }>());
export const couponDialogOpened = createAction('[Coupons] Detail dialog opened', props<{ dialogId: string }>());
export const closeCouponsDialog = createAction('[Coupons] Close detail dialog');
export const requestCloseCouponsDialog = createAction('[Coupons] Request Close Dialog');
export const confirmCloseCouponsDialog = createAction('[Coupons] Confirm Close Dialog');
export const cancelCloseCouponsDialog = createAction('[Coupons] Cancel Close Dialog');

export const showCoupons = createAction('[Coupons] Show coupon', props<{ coupon: CouponsDTO }>());
export const addCoupons = createAction('[Coupons] Add coupon');
export const loadCoupon = createAction('[Coupons] Load coupon', props<{ id: number }>());
export const loadCouponCompleted = createAction('[Coupons] Load coupon Completed', props<{ coupon: CouponsDTO }>());
export const loadCouponFailed = createAction('[Coupons] Load coupon Failed', props<{ error: any }>());

// Salvataggio coupon
export const saveCoupon = createAction('[Coupons] Save coupon', props<{ coupon: Coupons }>());
export const saveCouponCompleted = createAction('[Coupons] Save coupon completed', props<{ coupon: CouponsDTO }>());
export const saveCouponFailed = createAction('[Coupons] Save coupon failed', props<{ error: any }>());

// Eliminazione coupon
export const deleteCoupon = createAction('[Coupons] Delete coupon', props<{ coupon: CouponsDTO }>());
export const deleteCouponCompleted = createAction('[Coupons] Delete coupon completed', props<{ coupon: CouponsDTO }>());
export const deleteCouponCancelled = createAction('[Coupons] Delete coupon cancelled');
export const deleteCouponFailed = createAction('[Coupons] Delete coupon failed', props<{ error: any }>());

// Selezione coupon
export const selectCoupon = createAction('[Coupons] Select coupon', props<{ filters?: CouponsFilters }>());
export const selectionDialogOpened = createAction('[Coupons] Selection dialog opened', props<{ selectionDialogId: string }>());
export const closeSelectionDialog = createAction('[Coupons] Close selection dialog');
export const couponSelected = createAction('[Coupons] Coupon selected', props<{ coupon: CouponsDTO }>());

// Gestione selezione multipla
export const addSelectCoupons = createAction('[Coupons] Add selected coupons', props<{ coupon: Coupons }>());
export const removeSelectedCoupons = createAction('[Coupons] Remove selected coupons', props<{ coupon: Coupons }>());
export const resetSelectedCoupons = createAction('[Coupons] Reset selected coupons');
